import { Api } from 'further-types/investor';
import { investorTypeLabel } from 'further-ui/labels';
import { dateToLabel } from 'further-ui/utils';
import { IconButton } from '@mui/material';
import { useDisclosure } from 'further-ui/hooks';
import { CloudDownload, Delete } from '@mui/icons-material';
import AlertDialog from 'components/AlertDialog';
import { Row } from 'components/Layout';
import { useHasPermissions } from 'hooks/ui/usePermissions';
import { RolePermission } from 'further-types/admin-user-role';

type Props = {
  certification: Api.GetInvestorCertificationResponse[number];
  onDelete: (certificationId: string) => void;
  onDownload: (certification: Props['certification']) => void;
  isDeleting: boolean;
};

const ExpiredCertificationResult: React.FC<Props> = ({
  certification,
  onDelete,
  isDeleting,
  onDownload,
}) => {
  const deleteDisclosure = useDisclosure();
  const [canEdit] = useHasPermissions([RolePermission.EditInvestor]);

  return (
    <Row centered spacing="xs">
      <div>
        {investorTypeLabel[certification.investorType]}
        {` ${dateToLabel(
          certification.certificationPerformedAt,
          undefined,
          true,
        )}`}
      </div>

      {certification.createdBy?.investor && (
        <IconButton
          size="extra-small"
          title="Download"
          onClick={() => onDownload(certification)}
        >
          <CloudDownload color="primary" />
        </IconButton>
      )}

      {canEdit && (
        <IconButton
          size="extra-small"
          title="Delete"
          disabled={isDeleting}
          onClick={() => deleteDisclosure.onOpen()}
        >
          <Delete color="error" />
        </IconButton>
      )}

      <AlertDialog
        onClose={deleteDisclosure.onClose}
        open={deleteDisclosure.isOpen}
        title="Warning"
        content="Are you sure you wish to delete this classification? This cannot be undone."
        btnLabels={{ confirm: 'Delete', cancel: 'Go back' }}
        confirmBtnProps={{
          variant: 'contained',
          color: 'primary',
          disabled: isDeleting,
        }}
        onConfirm={() => {
          onDelete(certification._id);
          deleteDisclosure.onClose();
        }}
      />
    </Row>
  );
};

export default ExpiredCertificationResult;
